import React from "react";
//import ReactDOM from "react-dom";
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from "react-router-dom";
import { Provider } from 'react-redux';
import store from '../src/store';

import App from "./App";
import * as serviceWorker from "./serviceWorker";
import '../src/assets/css/vendor.bundle.css';
import '../src/assets/css/style.css';

const container = document.getElementById('root');
const root = createRoot(container);
root.render(
    <Provider store={store}><BrowserRouter>
        <App className="container" />
    </BrowserRouter></Provider>
);
/*ReactDOM.render(
    <Provider store={store}><BrowserRouter>
        <App className="container"/>
    </BrowserRouter></Provider>,
    document.getElementById("root")
);*/

serviceWorker.unregister();
